import cx from "classnames";
import React, { CSSProperties } from "react";
import styles from "./badge.module.scss";

export interface IBadge {
  variant:
    | "blue"
    | "red"
    | "pink"
    | "amber"
    | "purple"
    | "gray"
    | "blue-subtle"
    | "red-subtle"
    | "amber-subtle"
    | "purple-subtle"
    | "gray-subtle"
    | "gray-contrast"
    | "trial"
    | "turbo";

  size?: "sm" | "md" | "lg";

  children?: React.ReactNode;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const Badge = ({ variant, size = "md", ...props }: IBadge) => {
  return (
    <div
      className={cx(styles.badge, styles[variant], styles[size], props.className)}
      style={props.style}
      id={props.htmlId}
    >
      {props.children}
    </div>
  );
};

Badge.defaultProps = {};
